'use client';

import Image from 'next/image';

interface MercadoPagoBadgeProps {
  orientation?: 'horizontal' | 'vertical';
  variant?: 'soft' | 'plain';
  caption?: string;
  className?: string;
}

export default function MercadoPagoBadge({
  orientation = 'horizontal',
  variant = 'soft',
  caption = 'Pagos procesados de forma segura por Mercado Pago',
  className = '',
}: MercadoPagoBadgeProps) {
  const src =
    orientation === 'vertical'
      ? '/assets/payments/MP_RGB_HANDSHAKE_color_vertical.svg'
      : '/assets/payments/MP_RGB_HANDSHAKE_color_horizontal.svg';

  return (
    <div
      className={`${
        variant === 'soft'
          ? 'rounded-2xl border border-sky-100 bg-sky-50/80 px-4 py-3'
          : ''
      } ${className}`}
    >
      <div className="flex items-center gap-3">
        <div className="relative h-10 w-[126px] shrink-0">
          <Image src={src} alt="Mercado Pago" fill className="object-contain object-left" />
        </div>
        <p className={`text-sm ${variant === 'plain' ? 'text-white/92' : 'text-sky-900/85'}`}>{caption}</p>
      </div>
    </div>
  );
}
